module.exports = __webpack_public_path__ + "static/media/freelancer-onboarding-image.2f61e70c.webp";